import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const internationalFinancial: RouteObject = {
  id: "international-financial",
  path: "/international-financial",
  element: <DashboardPage />,
};

export default internationalFinancial;
